import { ReplaySubject } from 'rxjs';
import { Project } from '../../model/project';
import { Paginator, PaginatorEvent } from '../../model/paginator';
import {getCookie, setCookie} from "@/services/cookieClient/cookieClient";


const itemsPerPage = 9;

export class PaginatorData {

    private _data: ReplaySubject<PaginatorEvent>;
    public get data(): ReplaySubject<PaginatorEvent> {
        return this._data;
    }

    constructor(projects: Project[]) {
        this._data = new ReplaySubject<PaginatorEvent>();
        this.refreshSource(projects);
    }

    private paginator: Paginator = { itemsCnt: 0, pagesCnt: 0, selectedPage: 0, projectsToShow: [] };
    private allProjects: Project[] = [];

    refreshSource(projects: Project[]) {
        let storedSelectedPage :any= getCookie('paginator');
        if(storedSelectedPage == ""){
            storedSelectedPage = 1;
        }else{
            storedSelectedPage = parseInt(storedSelectedPage);
        }
        if(screen.width<=959){
            storedSelectedPage = 1;
        }

        this.allProjects = projects;
        this.paginator = { itemsCnt: projects.length, pagesCnt: Math.ceil(projects.length / this.getItemsPerPage()), selectedPage: storedSelectedPage, projectsToShow: [] };
        this.paginator.projectsToShow = this.getProjectsToShow();
        this._data.next({
            data: this.paginator,
            event: 'data-source-changed'
        });
    }

    private getItemsPerPage(){
        if(screen.width<=959){
            return 10000000;
        }else{
            return 9;
        }
    }

    private getProjectsToShow() {
        return this.allProjects.slice((this.paginator.selectedPage - 1) * this.getItemsPerPage(), this.paginator.selectedPage * this.getItemsPerPage());
    }

    public refreshSelection(selectedPage: number) {
        this.paginator.selectedPage = selectedPage;
        setCookie("paginator", selectedPage, 1);

        this.paginator.projectsToShow = this.getProjectsToShow();
        this._data.next({
            data: this.paginator,
            event: 'selection-changed'
        });
    }







}